module.exports = __webpack_public_path__ + "static/media/bryndwyr-3.055ec885.jpg";